<div class="row">
    <div class="col-sm-8 offset-sm-2">
        <app-error-page [errorData]="errorData"
                        [error]="error"
                        [title]="title">
        </app-error-page>
    </div>
</div>